if(!customElements.get('custom-contact-form')){

  class CustomContactForm extends HTMLElement {
    constructor(){
      super();
      this.init();
    }

    init(){
      // Form submission handler to prepend custom fields to body
      this.form = this.querySelector('form');
      if (this.form) {
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
      }

      // Required fields validation
      this.nameInput = this.querySelector('#input-name');
      this.emailInput = this.querySelector('#input-email');
      this.messageInput = this.querySelector('#input-body');
      this.consentCheckbox = this.querySelector('#consent-checkbox');
      this.submitButton = this.querySelector('button[type="submit"]');

      // Add listeners to all required fields
      const requiredFields = [this.nameInput, this.emailInput, this.messageInput];
      requiredFields.forEach(field => {
        if (field) {
          field.addEventListener('input', () => this.validateForm());
        }
      });

      if (this.consentCheckbox) {
        this.consentCheckbox.addEventListener('change', () => this.validateForm());
      }

      // Initial validation
      this.validateForm();
    }

    validateForm() {
      const nameValid = this.nameInput && this.nameInput.value.trim() !== '';
      const emailValid = this.emailInput && this.emailInput.value.trim() !== '';
      const messageValid = this.messageInput && this.messageInput.value.trim() !== '';
      const consentValid = this.consentCheckbox && this.consentCheckbox.checked;

      const allValid = nameValid && emailValid && messageValid && consentValid;

      if (this.submitButton) {
        this.submitButton.disabled = !allValid;
      }
    }

    handleSubmit(e) {
      const objetSelect = this.querySelector('#input-objet');
      const societeInput = this.querySelector('#input-societe');
      const bodyTextarea = this.querySelector('#input-body');

      if (objetSelect && bodyTextarea) {
        const objet = objetSelect.value;
        const societe = societeInput?.value?.trim() || '';
        const originalBody = bodyTextarea.value;

        // Build formatted body
        let formattedBody = `Objet: ${objet}\n`;
        if (societe) {
          formattedBody += `Société: ${societe}\n`;
        }
        formattedBody += `\n---\n\n${originalBody}`;

        // Use hidden input instead of modifying visible textarea
        const hiddenBody = document.createElement('input');
        hiddenBody.type = 'hidden';
        hiddenBody.name = 'contact[body]';
        hiddenBody.value = formattedBody;
        this.form.appendChild(hiddenBody);

        // Remove name from visible textarea so it doesn't submit
        bodyTextarea.removeAttribute('name');
      }
      // Form continues to submit normally
    }
  }

  customElements.define('custom-contact-form', CustomContactForm);

}
